import Preloader from "../../components/custom/preloader/preloader.vue";
import PhotoSection from "../../components/tour/photoSection/photoSection.vue";
import BookingSection from "../../components/tour/bookingSection/bookingSection.vue";
import DescriptionSection from "../../components/tour/descriptionSection/descriptionSection.vue";
import tourist from "../../components/booking/tourist/tourist.vue";

import {
  SETTING_CHANGE_PRELOAD,
  BANNER_GET_TOUR,
  BANNER_SAVE_TOUR,
  INIT_DATA_CITIZENSHIP_REF,
  META_PREPARE_TOUR_VISIT_COUNT,
  BANNER_PDF_TO_EMAIL,
  BANNER_CLEAR,
  BANNER_CLEAR_SEARCH,
  INIT_DATA_VISA_PERIOD,
  BANNER_TOURS_FILTER_CHANGE_CHECK_IN,
  BANNER_TOURS_FILTER_CHANGE_CHECK_OUT
} from "../../util/mutationTypes";

import download from "../../util/download";
import {
  PREPARE_TOUR_TYPE_REGIONAL,
  PREPARE_TOUR_TYPE_FIX,
  ROUTE_NAME_ORDER,
  ROUTE_NAME_INFO,
  INFO_TYPE_FIX_CREATED,
  ROUTE_NAME_TOURS
} from "../../util/enumTypes";

import TouristList from "../../models/TouristList";

const moment = require("moment");

export default {
  components: {
    Preloader,
    PhotoSection,
    BookingSection,
    DescriptionSection,
    tourist,
    modal: () =>
      import(
        /* webpackChunkName: "modal" */
        "../../components/custom/modal/modal.vue"
      )
  },
  data() {
    return {
      showTouristModal: false,
      tourists: [],
      comment: "",
      saveObject: null,
      tourCheckIn: null,
      discountDate: "0"
    };
  },
  computed: {
    tour() {
      return this.$store.state.BannerStorage.tour;
    },
    filter() {
      return this.$store.state.BannerStorage.filter;
    },
    lang() {
      return this.$store.state.SettingStorage.language.toLowerCase();
    },
    tourIdParam() {
      return this.$route.params.id;
    },
    btnName() {
        return this.$t("prepare_tour_save_region");
    },
    disabledCreateTour() {
      if (!this.tourists.length) {
        return true;
      }
      for (let i = 0; i < this.tourists.length; i++) {
        if (
          !this.tourists[i].lastName ||
          !this.tourists[i].firstName ||
          !this.tourists[i].birth
        ) {  
          return true;
        }
      }

      return false;
    },
    visaPeriods() {
      return this.$store.state.InitDataStorage.visaPariod;
    },
    visaNoTarif() {
      if (this.tourCheckIn) {
        return (
          this.visaPeriods.filter(
            v =>
              v.from.getTime() <= this.tourCheckIn &&
              v.to.getTime() >= this.tourCheckIn
          ).length == 0
        );
      }
      return true;
    }
  },
  methods: {
    async getTour() {
      this.$store.commit(SETTING_CHANGE_PRELOAD, true);
      this.$store
        .dispatch(BANNER_GET_TOUR, {
          lang: this.lang,
          tourId: this.tourIdParam,
          discountDate: this.discountDate
        })
        .then(() => {
          this.$store.commit(SETTING_CHANGE_PRELOAD, false);
        })
        .catch(() => {
          this.$store.commit(SETTING_CHANGE_PRELOAD, false);
        });

      this.discountDate = "0";
    },
    async bookingChangeCheckIn(checkIn) {
      this.discountDate = checkIn;
      await this.getTour();
    },
    async getCitizenshipRef() {
      if (!this.$store.state.InitDataStorage.citizenships.length) {
        this.$store.dispatch(INIT_DATA_CITIZENSHIP_REF, this.lang);
      }
    },
    async generateTourists(count) {
      this.tourists = new TouristList(
        count,
        this.$store.state.UserStorage.auth.companyCitizenship
      ).tourists;
    },
    async bookingSaveObject(val) {
      this.generateTourists(val.count);
      this.saveObject = val.data;
      this.showTouristModal = true;
      this.tourCheckIn = val.checkIn;
    },
    async closeShowTouristModal() {
      this.showTouristModal = false;
    },
    async downloadTourPDF() {
      if (this.tour && this.tour.pdfVersion) {
        download.getPDFByURL(this.tour.pdfVersion, this.tour.title + ".pdf");
      }
    },
    async sendEmailTourPDF() {
      this.$prompt(
        this.$t("prepare_tour_email_input"),
        this.$t("prepare_tour_email_title"),
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          inputPattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          inputErrorMessage: this.$t("prepare_tour_email_invalid")
        }
      )
        .then(({ value }) => {
          this.$store
            .dispatch(BANNER_PDF_TO_EMAIL, {
              bannerTourId: this.tourIdParam,
              email: value,
              lang: this.lang
            })
            .then(() => {
              this.$message({
                type: "success",
                message: this.$t("prepare_tour_email_send_ok", { email: value })
              });
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: this.$t("prepare_tour_email_send_error")
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("prepare_tour_email_send_canceled")
          });
        });
    },
    async getVisaPeriod() {
      if (!this.visaPeriods.length) {
        this.$store.dispatch(INIT_DATA_VISA_PERIOD, this.lang);
      }
    },
    setTouristToSaveObject() {
      this.tourists.forEach(t => {
        this.saveObject.tourists.push({
          id: t.guid,
          firstName: t.firstName,
          lastName: t.lastName,
          citizenId: t.citizenId,
          passport: t.passport,
          gender: t.gender,
          birth: t.birth,
          placeOfBirth: t.placeOfBirth,
          visa: t.visa
        });

        this.saveObject.segments[0].services[0].tourists.push(t.guid);
      });
    },
    async redirectAfterSave(tourId) {
        this.$router.push({
            name: ROUTE_NAME_ORDER,
            params: { id: tourId, lang: this.lang }
        });
    },
    async saveError() {
      this.$confirm(
        this.$t("prepare_tour_save_error"),
        this.$t("prepare_tour_save_error_title"),
        {
          confirmButtonText: "Ok",
          type: "error"
        }
      );
    },
    async clickConfirm() {
      this.setTouristToSaveObject();
      this.saveObject.commentary = this.comment;
      this.closeShowTouristModal();
      this.$store.commit(SETTING_CHANGE_PRELOAD, true);
      this.$store
        .dispatch(BANNER_SAVE_TOUR, { lang: this.lang, tour: this.saveObject })
        .then(resp => {
          this.$store.commit(SETTING_CHANGE_PRELOAD, false);
          if (resp.data.tourId == 0) {
            this.saveError();
          } else {
            this.redirectAfterSave(resp.data.tourId);
          }
        })
        .catch(() => {
          this.$store.commit(SETTING_CHANGE_PRELOAD, false);
          this.saveError();
        });
    },
    async userTourCounter() {
      this.$store.dispatch(META_PREPARE_TOUR_VISIT_COUNT, this.tourIdParam);
    },
    setDiscountDate() {
      this.discountDate =
        this.$route.params.checkInDate
          ? moment(this.$route.params.checkInDate).format("YYYY-MM-DD")
          : "0";
    }
  },
  mounted() {
    this.userTourCounter();
  },
  created() {
    if (this.$route.params.checkInDate) {
      this.$store.commit(BANNER_TOURS_FILTER_CHANGE_CHECK_IN, this.$route.params.checkInDate);
    }

    if (this.$route.params.checkOutDate) {
      this.$store.commit(BANNER_TOURS_FILTER_CHANGE_CHECK_OUT, this.$route.params.checkOutDate);
    }

    this.setDiscountDate();
    this.getVisaPeriod();
    this.getCitizenshipRef();
    this.getTour();
  },
  beforeDestroy() {
    this.$store.commit(BANNER_CLEAR);
    if (this.$route.name != ROUTE_NAME_TOURS) {
      this.$store.commit(BANNER_CLEAR_SEARCH);
    }
  }
};
